import React, { Fragment, useState } from 'react'

import TypeaheadInput from 'components/TypeaheadInput'

const SelectVolunteerToMessage = props => {
  const [state, setState] = useState(() => {
    return {
      ...props
    }
  })

  const onChange = value => {
    setState(() => ({ ...props }))

    const selected = state.options.find(item => item.value === value)

    var searchParams = new URLSearchParams()
    searchParams.append('companion_id', selected.value)

    window.location = state.url + '?' + searchParams
  }

  return (
    <Fragment>
      <div className='input required' id='select_volunteer_id_input'>
        <div className='org-typeahead'>
          <TypeaheadInput {...state} onChange={onChange} />
        </div>
      </div>
    </Fragment>
  )
}

export default SelectVolunteerToMessage
